import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { H1, Note, Button } from '../Common'

import style from './ForgotPasswordFinished.scss'

import cool from '../../images/emojis/cool.svg'

class ForgotPasswordFinished extends Component {
  static propTypes = {
    url: PropTypes.string.isRequired,
  }

  componentDidMount() {
    setTimeout(() => {
      window.location.href = this.props.url
    }, 2500)
  }

  render() {
    return (
      <div className={style.wrapper}>
        <img src={cool} alt="Emoji Feliz!" />
        <H1>sucesso!</H1>
        <p>Nossa equipe acaba de lhe enviar um e-mail com as boas vindas para a Hi Platform!</p>
        <Button xl>começar a usar</Button>
        <Note>redirecionamento automático em alguns segundos</Note>
      </div>
    )
  }
}

export default ForgotPasswordFinished



// WEBPACK FOOTER //
// ./src/components/Pages/SignupFinished.js